import { render, staticRenderFns } from "./ProgramBox.vue?vue&type=template&id=428e1d36&"
import script from "./ProgramBox.vue?vue&type=script&lang=js&"
export * from "./ProgramBox.vue?vue&type=script&lang=js&"
import style0 from "./ProgramBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports